import { useQuery } from "@tanstack/react-query";

export interface User {
  id: number;
  name: string;
  email: string;
  role: "admin" | "engineer";
}

export function useAuth() {
  return useQuery<User | null>({
    queryKey: ["auth-me"],
    queryFn: async () => {
      const res = await fetch(`${import.meta.env.BASE_URL}api/admin/me`, {
        credentials: "include",
      });
      if (!res.ok) return null;
      return res.json();
    },
    retry: false,
  });
}

export async function logout() {
  await fetch(`${import.meta.env.BASE_URL}api/admin/logout`, {
    method: "POST",
    credentials: "include",
  });
  window.location.href = `${import.meta.env.BASE_URL}admin`; // Using full page reload to clear state, or route to /admin
}
